module.exports = __webpack_public_path__ + "img/avatar-s-20.aa019f1d.png";